import {useContext} from 'react';
import {UseOfContextWithoutProviderError} from '@/types/errors';
import {AuthenticationContext} from './authentication.context';

export const useAuthentication = () => {
  const context = useContext(AuthenticationContext);

  if (context === undefined) {
    throw new UseOfContextWithoutProviderError('Authentication');
  }

  return context;
};
